import * as axiosBase from '@/api/index.js';

// 查询有数据的日期
export let queryDate = function(params) {
  return axiosBase.GET("/ijoou/data/queryDate", params)
}

// 健康报告
export let report = function(params) {
  return axiosBase.GET("/ijoou/data/report", params)
}



// WEBPACK FOOTER //
// ./src/api/ijoou/report.js